import { useState, useEffect } from "react";
import { SWIPER_V11_URL } from "@/constants";
import { addScriptToBody } from "@/util/dom";

const useSwiperScript = () => {
  const [loadedScriptStatus, setLoadedScriptStatus] = useState(
    () => typeof window !== "undefined" && Boolean(window.Swiper)
  );

  useEffect(() => {
    if (typeof window !== "undefined" && window.Swiper) {
      setLoadedScriptStatus(true);
      return;
    }
    const scriptExists = document.querySelector(
      `script[src="${SWIPER_V11_URL}"]`
    );
    if (scriptExists) {
      scriptExists.addEventListener("load", () => setLoadedScriptStatus(true));
      if ((window as any).Swiper) setLoadedScriptStatus(true);
      return;
    }
    addScriptToBody(SWIPER_V11_URL, () => setLoadedScriptStatus(true), true);
  }, []);

  return loadedScriptStatus;
};

export default useSwiperScript;
